"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectRestaurantList = void 0;
const React = require("react");
const react_1 = require("react");
const Grid_1 = require("../../../../../components/base/structure/Grid");
const RetailLocationCard_1 = require("../RetailLocationCard");
const NoDataFallback_1 = require("../../../../../components/base/structure/NoDataFallback");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const restaurantCard_1 = require("../../helpers/restaurantCard");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SelectRestaurantList");
const SelectRestaurantList = ({ restaurants, currentOrderType, selectRestaurant }) => {
    const { retailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    (0, react_1.useEffect)(() => {
        if (!retailLocation) {
            return;
        }
        (0, restaurantCard_1.hoverRestaurantCard)(retailLocation, false);
    }, [retailLocation]);
    return (React.createElement("div", { className: css("") }, Array.isArray(restaurants) && (React.createElement(React.Fragment, null, restaurants.length > 0 ? (React.createElement(Grid_1.Grid, { className: css("grid"), size: "lg" }, restaurants.map(restaurant => (React.createElement(RetailLocationCard_1.RetailLocationCard, { key: `restaurant-select-${restaurant.retailLocationId}`, retailLocation: restaurant, onClick: async () => {
            await selectRestaurant(restaurant);
        }, orderType: currentOrderType }))))) : (React.createElement(NoDataFallback_1.NoDataFallback, { message: "No available stores nearby" }))))));
};
exports.SelectRestaurantList = SelectRestaurantList;
//# sourceMappingURL=index.js.map